require('./retailLoanCarousel.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const Slider = require('react-slick').default;
//@components
const RetailLoanArrow = require('../retailLoanArrow/retailLoanArrow');
const { RetailLoanCarouselSection } = require('../retailLoanCarousel/retailLoanCarouselSection');
// @helpers
const {
    PROC_RETAIL_LOAN,
    EVENT_CAROUSEL_NEXT,
    EVENT_CAROUSEL_PREV,
    recordLink
} = require('utilities/tagging');

class RetailLoanCarousel extends React.Component {

    constructor(props) {
        super(props);

        this.handleArrow = this.handleArrow.bind(this);
    }

    buildListOfCarousel(item, index) {
        const { labels, setItemProduct, handleProductsClick } = this.props;
        return (
            <div key={index}>
                <RetailLoanCarouselSection
                    item={item}
                    labels={labels}
                    setItemProduct={setItemProduct}
                    handleProductsClick={handleProductsClick} />
            </div>
        );
    }

    handleArrow(oldIndex, newIndex) {
        let eventName = newIndex > oldIndex ? EVENT_CAROUSEL_NEXT : EVENT_CAROUSEL_PREV;
        recordLink(PROC_RETAIL_LOAN, eventName);
    }

    render() {
        const { listItems } = this.props;
        const settings = {
            beforeChange: this.handleArrow,
            dots: false,
            slidesToShow: 2,
            infinite: false,
            prevArrow: <RetailLoanArrow icon={"icon-anterior"} />,
            nextArrow: <RetailLoanArrow icon={"icon-siguiente"} />
        };

        return (
            <div className="col-md-12 col-lg-12 retail-loan-carousel__container">
                <Slider {...settings}>
                    {listItems.map((item, index) => this.buildListOfCarousel(item, index))}
                </Slider>
            </div>
        );
    }

}

RetailLoanCarousel.propTypes = {
    listItems: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    setItemProduct: PropTypes.func,
    handleProductsClick: PropTypes.func,
}

export { RetailLoanCarousel };
